exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-rates-component[data-v-3fad2ca0] {\r\n    padding-bottom: 6em;\n}\r\n", ""]);

// exports
